import React from "react";
import ServiceCard from "./ServiceCard";
import Currency1 from "../assests/currency-1.png"
import Currency2 from "../assests/currency-2.png"
import Currency3 from "../assests/currency-3.png"
import { useInView } from 'react-intersection-observer';


const SERVICE_DATA = [
  {
    title: "Currencies",
    image: Currency1,
    text: "Trade the world’s largest market with spreads starting from 0 pips",
  },
  {
    title: "Stocks",
    image: Currency2,
    text: "Trade stocks of the biggest names in the international stock market with low transaction costs",
  },
  {
    title: "Commodities",
    image: Currency3,
    text: "Diversify your portfolio and trade oil, natural gas and metals",
  },
];

const ServiceStyles = {
  container: "flex flex-col bg-gray-200  py-6  space-y-6 md:py-16",
  top: "flex items-center justify-center",
  top__left__div: "flex flex-col space-y-6",
  top__left__div__p: "font-inter flex-1 text-md font-bold text-indigo-800",
  top__left__div__h3:
    "font-inter text-3xl text-center md:text-5xl font-semibold text-gray-900 leading-snug",
  top__right__div:
    "w-[311px] md:w-[400px] flex items-center font-inter text-lg font-semibold text-[#8696ae]",
  bottom: "flex flex-col space-y-6 md:space-y-0 md:flex-row md:space-x-6 md:justify-between p-6 lg:px-28",
};

const Service = () => {
  const [serviceRef, inViewService] = useInView({
    triggerOnce: true, // Trigger the animation only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  return (
    <section ref={serviceRef} className={ServiceStyles.container}>
      {/* Top Part */}
      <div className={`${ServiceStyles.top} ${inViewService ? 'animate-slideInFromBottom transition duration-500 ease-in' :''} `}>
        <h3 className={ServiceStyles.top__left__div__h3}>
        Access and trade global markets
        </h3>
      </div>

      {/* Bottom Part Card Sections */}

      <div className={`${ServiceStyles.bottom} ${inViewService ? 'animate-slideInFromBottomCard transition duration-500 ease-in' :''}`}>
        {SERVICE_DATA.map((item) => (
          <ServiceCard
            key={item.title}
            title={item.title}
            image={item.image}
            text={item.text}
  
          />
        ))}
      </div>
    </section>
  );
};

export default Service;
